export class UpdateControlDto {
    dateFrom;
    dateTo;
    dateStart;
    dateEnd;
    isFollowUp;
    followUpStatus;
    followUpNote;
    creationPerson;
    creationDate;
    listValidated;
    modificationPerson;
    modificationDate;
    program;
    controlKinds;
    controlMode;
    controlType;
    controllers;
    teamLeader;
    questionListId;
    controlledParties=[];
    controlPlaces=[];
    paymentClaims=[];
    orders=[];
    answers=[];
    answerBlockStatus=[];
    postControlDocuments;
}
